<div class="fix-left-section-container">
  <!-- Share Section -->
  <div class="share-section mb-4">
    <div class="share-text mb-2">شارك المقال على</div>
    <div class="social-icons d-flex justify-content-end gap-2">
      <a href="#" class="social-icon">
        <i class="fa-brands fa-twitter"></i>
      </a>
      <a href="#" class="social-icon">
        <i class="fa-brands fa-facebook-f"></i>
      </a>
    </div>
  </div>

  <!-- Watch Also Section -->
  <div class="watch-also-wrapper position-relative">
    <div class="green-backdrop"></div>
    <div class="gray-content-card">
      <h4 class="section-title mb-4">شاهد ايضا</h4>
      <ul class="custom-list p-0 m-0">
        <li>
          <a                 [routerLink]="'/mediacenter'"
 routerLinkActive="active"
            > المركز الإعلامى</a
          >
        </li>

        <li>
          <a                     [routerLink]="'/medianews'"
 routerLinkActive="active"
            >  الأخبار</a
          >
        </li>

        <li>
          <a [routerLink]="'/mediaActions'" routerLinkActive="active"
            > الاحداث  </a
          >
        </li>
                <li>
          <a                     [routerLink]="'/mediaVideos'"
 routerLinkActive="active"
            > معرض الفيديو  </a
          >
        </li>
      </ul>
    </div>
  </div>
</div>
